export interface IStockMovementReport {
  stockMovements: IStockMovementReportLineItem[];
  totalOpeningStock: number;
  totalStockIn: number;
  totalStockOut: number;
  totalTransferredIn: number;
  totalTransferredOut: number;
  totalSold: number;
  totalClosingStock: number;
}

export interface IStockMovementReportLineItem {
  totalConversionIn: any;
  totalStockTakeAdjustmentIn: any;
  hadMovement?: boolean;
  totalProducedStock: any;
  product: {
    id: string;
    name: string;
    sku: string;
    code: string;
  };
  categories: {
    id: string;
    name: string;
    department: { id: string; name: string };
  }[];
  totalStockIn: number;
  totalPurchased: number;
  totalStockOut: number;
  totalTransferredPendingIn: number;
  totalTransferredIn: number;
  totalTransferredOut: number;
  totalTransferredPendingOut: number;
  totalInTransit: number;
  totalDelivered: number;
  totalSold: number;
  openingStock: number;
  closingStock: number;
  totalSalesCancelled: number;
  totalReturned: number; // keep in mind this is not an actual return but a counter balance on the logistics to the customer eg stock loaded from depot to vehicle for delivery, without this we will incorrectly tally the sales until the system is changed to use order delivered stock event type.
  calculatedTotal?: number; // this variable is used on the frontend to calculate the returned values from api, we could probably do that on the api but this is fine
}
